import React from 'react'

export const Pagination = () => {
    return (
        <>
            <div className="clearfix"></div>
            <div className="row">
                <div className="col-md-12">
                    {/* <!-- Pagination --> */}
                    <div className="pagination-container margin-top-20 margin-bottom-40">
                        <nav className="pagination">
                            <ul>
                                <li><a href="#" className="current-page">1</a></li>
                                <li><a href="#">2</a></li>
                                <li><a href="#">3</a></li>
                                <li><a href="#"><i className="sl sl-icon-arrow-right"></i></a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    )
}